import { render, staticRenderFns } from "./FasilitatorList.vue?vue&type=template&id=10b5d6d7"
import script from "./FasilitatorList.vue?vue&type=script&lang=js"
export * from "./FasilitatorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports